exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label[data-v-0d16268e] {\n  font-size: 1rem;\n  vertical-align: middle;\n  cursor: pointer;\n}\ninput[type=checkbox][data-v-0d16268e] {\n  vertical-align: middle;\n}\n.badge[data-v-0d16268e] {\n  vertical-align: top;\n  border-radius: 100px;\n  color: #3f4d51;\n  background-color: #dde3e5;\n  padding: 4px 8px;\n  min-height: 18px;\n  min-width: 18px;\n  vertical-align: baseline;\n}", ""]);

// exports
